import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

export const HeadingCombo: FC<{
  className?: string;
}> = ({ children, className }) => {
  return <div className={twMerge('flex flex-col gap-e8', className)}>{children}</div>;
};
